<abp-modal [(visible)]="openModal" (disappear)="modalClose.emit(false)">
  <ng-template #abpHeader>
    <div class="flex flex-col gap-1">
      <h3 class="font-semibold !text-[18px]">
        {{ 'RegisterService::' + ((type | titlecase) + 'Assets') | abpLocalization }}:
        <label class="font-medium text-[16px]">
          {{ (asset.primaryIdPrefix ?? '') + asset.primaryID }}
        </label>
      </h3>

      <span
        class="text-[16px]"
        *ngIf="(subAssets.length || asset.components) && !isLoading && !loadError"
      >
        {{ 'RegisterService::ConfirmMessage' | abpLocalization }}
      </span>
      <span class="text-[14px] text-red-600 flex items-center gap-2" *ngIf="loadError">
        {{ loadError }}
      </span>
      <span class="text-[14px] text-gray-600" *ngIf="isLoading">
        {{ 'AbpUi::Loading' | abpLocalization }}...
      </span>
    </div>
  </ng-template>
  <ng-template #abpBody>
    <div *ngIf="!isLoading && subAssets.length === 0" class="mb-3">
      <span class="text-[14px] text-red-600">
        {{ loadError || 'Failed to load sub assets' }}
      </span>
    </div>
    <div class="gap-3" *ngIf="subAssets.length">
      <label
        class="form-label mb-2 font-medium text-[16px]"
        *ngIf="subAssets.length && !isLoading && !loadError"
      >
        {{ 'RegisterService::SubAssets' | abpLocalization }}
      </label>
      <div *ngFor="let item of subAssets">
        <div class="flex gap-2">
          <div class="flex flex-col w-full gap-2">
            <div class="space-x-2">
              <input
                type="checkbox"
                class="form-check-input min-w-[1.25em]"
                [id]="item.id"
                [disabled]="transferData.missingIds.includes(item.id)"
                (change)="selectSubAssets($event, item)"
                [checked]="isSelected(item.id)"
              />
              <label class="font-medium text-[16px]">
                {{ (item.primaryIdPrefix ?? '') + item.primaryID }}
              </label>
              <!-- <label class="form-label">
                {{ item.categoryNickname }}
              </label> -->
            </div>
            <div class="flex flex-col ml-7" *ngIf="item.components">
              <label class="form-label font-medium text-[14px]" for="asset-components">
                {{ 'RegisterService::Components' | abpLocalization }}
              </label>
              <div class="form-check flex items-center gap-2">
                <input
                  type="checkbox"
                  class="form-check-input min-w-[1.25em]"
                  [id]="item.id"
                  [disabled]="transferData.missingIds.includes(item.id)"
                  (change)="selectSubComponents($event, item.id)"
                  [checked]="isSubComponentSelected(item.id)"
                />

                <textarea
                  id="asset-components-{{ item.id }}"
                  [value]="item.components"
                  rows="3"
                  class="form-control"
                  maxlength="5120"
                  readonly
                ></textarea>
              </div>
            </div>
          </div>
          <div class="flex h-max">
            <button
              *ngIf="!isSelected(item.id)"
              type="button"
              [ngClass]="transferData.missingIds.includes(item.id) ? 'btn-secondary' : 'bg-danger'"
              class="btn py-0.5 px-3 text-white"
              (click)="setMissing(item.id)"
            >
              {{
                (transferData.missingIds.includes(item.id)
                  ? 'RegisterService::Discard'
                  : 'RegisterService::Missing'
                ) | abpLocalization
              }}
            </button>
          </div>
        </div>
      </div>

      <div class="flex flex-col my-2" *ngIf="asset.components">
        <label class="form-label font-medium text-[16px]" for="asset-components-root">
          {{ 'RegisterService::Components' | abpLocalization }}
        </label>
        <div class="form-check flex items-center gap-2">
          <input
            type="checkbox"
            class="form-check-input min-w-[1.25em]"
            id="components"
            (change)="selectComponents($event)"
            [checked]="transferData.componentStatus === ComponentStatus.Exist"
          />

          <textarea
            id="asset-components-root"
            [value]="asset.components"
            rows="3"
            class="form-control"
            maxlength="5120"
            readonly
          ></textarea>
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label font-medium text-[16px]" for="asset-notes">
          {{ 'RegisterService::Notes' | abpLocalization }}
        </label>
        <textarea
          id="asset-notes"
          rows="3"
          [(ngModel)]="transferData.notes"
          class="form-control"
          maxlength="5120"
        ></textarea>
      </div>
    </div>
  </ng-template>
  <ng-template #abpFooter>
    <ng-container *ngIf="!isLoading && subAssets.length === 0; else normalFooter">
      <button type="button" class="btn btn-primary" (click)="retry()">
        {{ 'AbpUi::Retry' | abpLocalization }}
      </button>
      <button type="button" class="btn btn-secondary" abpClose>
        {{ 'AbpUi::Close' | abpLocalization }}
      </button>
    </ng-container>
    <ng-template #normalFooter>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="isBusy || isLoading"
        (click)="onTransfer()"
      >
        {{ 'AbpUi::Apply' | abpLocalization }}
      </button>
      <button type="button" class="btn btn-secondary" abpClose>
        {{ 'AbpUi::Close' | abpLocalization }}
      </button>
    </ng-template>
  </ng-template></abp-modal
>
